import React from "react";

import { useLocation } from "react-router";

export function useScrollToTopOnNavigationChange({ outletDiv }: { outletDiv: React.RefObject<HTMLDivElement> }) {
  const { pathname } = useLocation();

  return React.useLayoutEffect(() => {
    if (!outletDiv.current) return;

    outletDiv.current.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname, outletDiv]);
}
